<template>
  <v-app class="page page-base">
    <v-app-bar
      class="header-list pl-6 pr-8 py-3"
      app
      fixed
      elevation="0"
      color="lightPrimary"
      height="80"

    >
      <div class="d-flex flex-grow-1 justify-space-between">
        <div class="d-flex align-center">
          <div class="d-flex gp-8">
            <v-btn text class="custom-btn-icon-gray pa-3 icon-tam-20" v-on:click="
              $router.push('/admin/users_scroll')
              ">
              <v-icon>$arrowRightIcon</v-icon>
            </v-btn>
          </div>
            <v-breadcrumbs
                class="menu-breadcrumbs pa-0 ml-4"
                :items="breadcrumbs"
                divider=">"
                    >
              </v-breadcrumbs>
        </div>
        <div class="d-flex align-center">
          <v-switch
            v-model="has_sticker"
            label="Cartel colocado"
            hide-details
            class="switch_filter"
          />

          <v-spacer />

          <v-switch
            v-model="verified"
            label="Verificado"
            hide-details
            class="switch_filter"
          />
        </div>
      </div>
      
      <!-- <b>{{ title }}</b>

      <v-spacer />

      <v-switch
        v-model="has_sticker"
        label="Cartel colocado"
        hide-details
        class="switch_filter"
      />

      <v-spacer />

      <v-switch
        v-model="verified"
        label="Verificado"
        hide-details
        class="switch_filter"
      /> -->

    </v-app-bar>
    <v-main>
      <v-container fluid class="fill-height pr-0 pa-0">
        <v-card
          width="100%"
          elevation="0"
          class="full-height fill-width fill-height card-content"
          :loading="status == 'loading'"
        >
          <v-card-text>
            <v-row>
              <map-component :markers="markers" :initial-center="initialCenter" :initial-zoom="initialZoom" :map-height="mapHeight" />
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import {mapState} from 'vuex';
  import MapComponent from "@/components/Map/index.vue";

  export default {
    components: {
      MapComponent,
    },
    data() {
      return {
        breadcrumbs: [
        {
          text: "General",
          disabled: false,
          href: "#",
        },
        {
          text: "Mapa",
          disabled: false,
          href: "#",
        },
      ],
        storeName: "Map",
        title: "Mapa",
        markers: [],
        initialCenter: { lat: -34.615796, lng: -58.5156988 },
        initialZoom: 12,
        mapHeight: '800px',
        has_sticker: true,
        verified: true,
      };
    },
    computed: {
      ...mapState({
        status: state => state.Map.status,
      })
    },
    async created() {
    },
    watch: {
      has_sticker(newValue) {
        this.getSpots({has_sticker: newValue, verified: this.verified});
      },
      verified(newValue) {
        this.getSpots({verified: newValue, has_sticker: this.has_sticker});
      },
    },
    mounted() {
      this.getSpots({has_sticker: this.has_sticker, verified: this.verified});
    },
    methods: {
      async getSpots(filter = {}){
        const self = this;

        let filters = {
          ...filter,
          show_all: 'enable',
          deleted: false
        }

        await this.$store.dispatch("Spots/getListAll", filters).then((spots)=>{
          self.markers = spots.map((spot,index)=>{
            let marker = {
              id: index,
              position: { lat: spot.latitude, lng: spot.longitude },
              title: spot.title || '',
              alias: spot.alias_id || '',
            }
            return marker;
          });
        });
      }
    }
  };
</script>
